// @flow

import { connect } from 'react-redux';

import * as ZapImportJob from 'app/entities/ZapImportJob';
import ZapImportErrorsModal from 'app/settings/components/ZapImportErrorsModal/ZapImportErrorsModal';

import { type Dispatch } from 'app/common/types';

const mapStateToProps = state => {
  const showingForCid = ZapImportJob.selectors.all.showingImportErrorsFor(
    state
  );
  const job = ZapImportJob.selectors.all.entityByCid(showingForCid, state);
  return {
    failedZaps: ZapImportJob.selectors.failures(job),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onClose() {
    dispatch(ZapImportJob.actions.hideImportErrors());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ZapImportErrorsModal);
